import { SupabaseClient } from '@supabase/supabase-js';

import { Database, withLogs } from '@core';

export type RemoteI18nMaps = Record<'en_US' | 'is_IS', Record<string, string>>;
const PAGE_SIZE = 1000;

export const fetchI18n = withLogs(async (supabase: SupabaseClient<Database>) => {
    // First request: get count + first page simultaneously
    const {
        data: firstPage,
        error,
        count,
    } = await supabase
        .from('i18n')
        .select('*', { count: 'exact' })
        .range(0, PAGE_SIZE - 1);

    if (error) throw error;

    // Fetch remaining pages in parallel
    const remainingPages = Math.ceil((count! - PAGE_SIZE) / PAGE_SIZE);
    const results = await Promise.all(
        Array.from({ length: remainingPages }, async (_, i) => {
            const from = (i + 1) * PAGE_SIZE;
            return supabase
                .from('i18n')
                .select('*')
                .range(from, from + PAGE_SIZE - 1)
                .then(({ data, error }) => {
                    if (error) throw error;
                    return data;
                });
        }),
    );

    const allRows = [firstPage, ...results].flat();

    return allRows.reduce(
        (acc, { i18n_key, en_us, is_is }) => {
            if (en_us) acc.en_US[i18n_key] = en_us;
            if (is_is) acc.is_IS[i18n_key] = is_is;
            return acc;
        },
        { en_US: {}, is_IS: {} } as RemoteI18nMaps,
    );
}, 'fetchI18n');
